import request from '@/utils/request'

// 异常订单分页查询
export function pageOrderAbnormal(query) {
  return request({
    url: '/order/abnormal/page',
    method: 'get',
    params: query
  })
}

// 处理异常订单（标记为已处理）
export function resolveOrderAbnormal(data) {
  return request({
    url: '/order/abnormal/resolve',
    method: 'post',
    data: data
  })
}
